module.exports = __webpack_public_path__ + "static/microsoft_365_5-03490a32834a2d5e288587a4e5ae4cc6.png";